module.exports = __webpack_public_path__ + "static/media/current-address.1585dc87.svg";